/** The find worker started from its bundle under the app's Trusted Types policy (part 19a; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { FindWorker } from './host.ts';

/** T1, T4: a function starting a find worker (a module worker); the host starts another after ending one. */
export function findWorker(source: WorkerSource<FindWorker>): () => FindWorker {
  return () => new source.Worker(source.trusted(source.url), { type: 'module', name: 'find' });
}
